import logo from '@/assets/logo.png';
import {setTitle, storage} from "@/utils";
import {getApp} from "@/api/auth/organization";
import {banners} from "@/api/community/banner";

const initializeState = {
    globalMessage: {
        message: '',
        resolve: () => {}
    },
    org: null,
    name: '图形化在线编程',
    logo: logo,
    title: '',
    banner: [],
    initRouter: false
};

const app = {
    state: {
        ...Object.assign(
            {},
            initializeState,
            storage.getLocal('app'),
            {org: storage.getCookie('org')},
            {banner: storage.getLocal('banner')}
        )
    },
    getters: {
        globalMessage:  state => state.globalMessage,
        org:            state => state.org,
        name:           state => state.name,
        logo:           state => state.logo,
        title:          state => state.title || state.name,
        banner:         state => state.banner,
        initRouter:     state => state.initRouter
    },
    mutations: {
        SET_GLOBAL_MESSAGE: (state, globalMessage) => {
            state.globalMessage = globalMessage;
        },
        SET_TITLE: (state, title) => {
            if (title) {
                state.title = `${title}-${state.name}`;
            }
        },
        SET_APP: (state, app) => {
            state.org = app.id;
            state.name = app.name;
            state.logo = app.logo;
            storage.setLocal('app', app);
            storage.setCookie('org', app.id);
        },
        SET_BANNER: (state, banner) => {
            state.banner = banner;
            storage.setLocal('banner', banner);
        },
        RESET_APP_INFO: (state) => {
            state.name = initializeState.name;
            state.logo = initializeState.logo;
        },
        SET_INIT_ROUTER: (state) => {
            state.initRouter = true;
        }
    },
    actions: {
        async loadApp({commit, state, dispatch}) {
            if (!state.org) {
                let {data} = await getApp();
                if (data) {
                    commit('SET_APP', data);
                    setTitle(data.name);
                }
            }
            await dispatch('loadBanner');
        },
        async loadBanner({commit}) {
            let {data} = await banners();
            commit('SET_BANNER', data);
        }
    }
};

export default app;
